import Footer from "../../footer/footer";
import Ribbon from "../../ribbon/ribbon";
import Alpine from "alpinejs";
import { Route } from "./route";
import Routes from "./routes";
import Router from "./router";
/// <reference path="../../../infrastructure/types/global.d.ts" />
const footer = document.querySelector("footer") as HTMLElement;
const ribbon = document.getElementById("ribbon-container") as HTMLElement;
const ApplicationTitle = "JoelStamey.com";
const ApplicationRoot = document.querySelector("main") as HTMLElement;

const app = async () => {
  (window as any).Alpine = Alpine;
  Alpine.start();
  footer.innerHTML = Footer();
  ribbon.innerHTML = Ribbon();
  const ApplicationRoutes = GetRoutes();
  (new Router(ApplicationRoot, ApplicationTitle, ApplicationRoutes)).RouterInit();
};

// Load app
app();

function GetRoutes(): Routes {
  let routes = new Routes();
  routes.add("404", new Route("/notfound/notfound.html", "404", "Page not found", "notfound/feature-notfound.css", ""));
  routes.add("/", new Route("/home/home.html", "Home", "JoelStamey.com Home Page", "home/feature-home.css", ""));
  routes.add("/home", new Route("/home/home.html", "Home", "JoelStamey.com Home Page", "home/feature-home.css", ""));
  routes.add("/about", new Route("/about/about.html", "About Us", "This page describes the technologies used in this site.", "about/feature-about.css", ""));
  routes.add("/contact", new Route("/contact/contact.html", "Contact Us", "How to contact the site owners.", "contact/feature-contact.css", ""));
  routes.add("/design", new Route("/design/design.html", "Design Elements", "Design elements in this site.", "design/feature-design.css", "scripts/progressbar.js"));
  return routes;
}
